import { render, staticRenderFns } from "./VSwitchWithPopover.vue?vue&type=template&id=a71960a4"
import script from "./VSwitchWithPopover.vue?vue&type=script&lang=js"
export * from "./VSwitchWithPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports